import { render, staticRenderFns } from "./CefrModal.vue?vue&type=template&id=4ed1afae&scoped=true"
import script from "./CefrModal.vue?vue&type=script&lang=js"
export * from "./CefrModal.vue?vue&type=script&lang=js"
import style0 from "./CefrModal.vue?vue&type=style&index=0&id=4ed1afae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1afae",
  null
  
)

export default component.exports